module.exports = __webpack_public_path__ + "img/leaflet_extended.ade11415.png";